import pinia from '@/pinia';
import useStore from './useMeStore';

export default () => useStore(pinia);
